// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__Pp4Zg","homePage":"style_homePage__s5_xg","logo":"style_logo__IVIWQ"};